import * as React from 'react';
import { SectionNotification } from 'wix-ui-tpa';
import { DataHook } from '../ApplyOffer';
import { Error as ErrorIcon } from '../../icons/dist';
export var ErrorSection = function (props) {
    var errorMessage = props.errorMessage, errorViewType = props.errorViewType;
    return (React.createElement(SectionNotification, { type: "error", "data-hook": DataHook.OfferInputSectionError + "-" + errorViewType },
        React.createElement(SectionNotification.Icon, { icon: React.createElement(ErrorIcon, null) }),
        React.createElement(SectionNotification.Text, null, errorMessage)));
};
//# sourceMappingURL=ErrorSection.js.map